/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */

const AUTH_STATUS_OPTIONS = {
  0: {
    value: '0',
    label: '未授权'
  },
  1: {
    value: '1',
    label: '已授权'
  }
};

export default {
  fullName: {
    label: '项目参与人',
    width: 180,
    prop: 'fullName'
  },
  phone: {
    label: '手机号',
    width: 180,
    prop: 'phone'
  },
  projectName: {
    label: '项目名称',
    width: 180,
    prop: 'projectName'
  },
  projectNo: {
    label: '项目编码',
    width: 180,
    prop: 'projectNo'
  },
  enterpriseName: {
    label: '验证企业',
    width: 180,
    prop: 'enterpriseName',
    formatter(r, c, v) {
      return v || '-';
    }
  },
  createDt: {
    label: '更新时间',
    width: 180,
    prop: 'createDt'
  },
  authStatus: {
    label: '授权状态',
    prop: 'authStatus',
    formatter(r, c, v) {
      return AUTH_STATUS_OPTIONS[v].label;
    }
  },
  isEmploy: {
    label: '是否存在报税关系',
    prop: 'isEmploy',
    formatter(r, c, v) {
      if (v !== 0 && v !== 1) {
        return '-';
      }
      return v ? '是' : '否';
    }
  },
  isSettlement: {
    label: '是否可结算',
    prop: 'isSettlement',
    formatter(r, c, v) {
      return v ? '可结算' : '不可结算';
    }
  }
};
